import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const ArrowDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{
        '&:hover': {
          circle: { fill: 'black' },
          path: { fill: 'white' }
        }
      }}>
      <svg
        width='36'
        height='36'
        viewBox='0 0 36 36'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <circle cx='18' cy='18' r='18' fill='#F2F2F2' />
        <path
          d='M18.1314 22.6278C18.3407 22.6278 18.5499 22.5441 18.6923 22.385L25.1711 15.7472C25.3134 15.6049 25.3971 15.4208 25.3971 15.2115C25.3971 14.7762 25.0706 14.4414 24.6354 14.4414C24.4261 14.4414 24.2336 14.5251 24.0912 14.659L17.6794 21.2132H18.5751L12.1632 14.659C12.0293 14.5251 11.8368 14.4414 11.6191 14.4414C11.1839 14.4414 10.8574 14.7762 10.8574 15.2115C10.8574 15.4208 10.9411 15.6049 11.0834 15.7556L17.5622 22.385C17.7213 22.5441 17.9138 22.6278 18.1314 22.6278Z'
          fill='black'
        />
      </svg>
    </SvgIcon>
  )
}
